import { render } from "./my_project_data.vue?vue&type=template&id=1acc5d6b&scoped=true"
import script from "./my_project_data.vue?vue&type=script&lang=js"
export * from "./my_project_data.vue?vue&type=script&lang=js"

import "./my_project_data.vue?vue&type=style&index=0&id=1acc5d6b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1acc5d6b"]])

export default __exports__